'use client';
import React from 'react';
import { CartSummary as Shared } from '@launchstore/shared-puck';
import { usePuckContext } from '@/components/puck/PuckContextProvider';

const SharedRender = (Shared as any).render;

/**
 * Storefront CartSummary — derives totals (numbers in cents) from the
 * live cart in Puck context. Falls back to the shared MOCK only in
 * editor preview.
 */
function CartSummaryImpl(props: any) {
  const { context } = usePuckContext() as any;
  const cart = context?.cart;

  if (!cart) {
    return <SharedRender {...props} totals={undefined} />;
  }

  const totals = {
    subtotal: Number(cart.subtotal) || 0,
    shipping: Number(cart.shipping_total) || 0,
    tax: Number(cart.tax_total) || 0,
    discount: Number(cart.discount_total) || 0,
    total: Number(cart.total) || 0,
  };

  return <SharedRender {...props} totals={totals} />;
}

export const CartSummary: any = {
  ...Shared,
  render: (props: any) => <CartSummaryImpl {...props} />,
};
export default CartSummary;
